<template>
  <div v-if="permissions">
    <ResponsiveDialog :visible="visible" header="Change Permissions" width="500px" @update:visible="$emit('update:visible', false)">
      <PVCard>
        <template #content>
          <div class="flex pvflex flex-col">
            <div>
              <ContactConfigSwitchComponent label="Super Admin" hint="Toggles on/off super admin features">
                <PVCheckbox :modelValue="superAdmin" :binary="true" style="margin-top: 12px;" @update:modelValue="toggleSuperAdmin"/>
              </ContactConfigSwitchComponent>
            </div>
            <div v-for="permission in permissionsKeys" :key="permission" wrap>
              <div>
                <ContactConfigSwitchComponent :label="permission + ' view'" hint="Toggles on/off viewing">
                  <PVCheckbox :modelValue="getPermission(permission)?.view ?? false" :binary="true" style="margin-top: 12px;" @update:modelValue="togglePermissions(permission, 'view', $event)"/>
                </ContactConfigSwitchComponent>
              </div>
              <div>
                <ContactConfigSwitchComponent :label="permission + ' create'" hint="Toggles on/off creating">
                  <PVCheckbox :modelValue="getPermission(permission)?.create ?? false" :binary="true" style="margin-top: 12px;" @update:modelValue="togglePermissions(permission, 'create', $event)"/>
                </ContactConfigSwitchComponent>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex pvflex flex-row align-center justify-end mt-2">
            <PVButton raised class="uppercase nowrap" severity="error" label="Reset" @click="authStore.togglePermissionsReset()"/>
          </div>
        </template>
      </PVCard>
    </ResponsiveDialog>
  </div>
</template>

<script lang="ts">
import { useAuthStore, type PermissionDetailsKey } from '@/stores/authentication.js';
import ContactConfigSwitchComponent from "@/components/patients/patient/contacts/ContactConfigSwitchComponent.vue";
import ResponsiveDialog from "@/components/common/dialogs/ResponsiveDialog.vue";
import { defineComponent } from 'vue';

export default defineComponent({
  name: "SuperPermissionsToggleDialog",
  components: { ResponsiveDialog, ContactConfigSwitchComponent },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  emits:['update:visible'],
  data() {
    return {
      permissionsKeys: [
        'patients',
        'contacts',
        'monitoring',
        'tags',
        'companies',
        'events',
        'pack'
      ] as PermissionDetailsKey[],//(keyof Omit<Permissions, 'dirty'>)[],
    }
  },
  computed: {
    superAdmin() {
      return this.authStore.access.superAdmin;
    },
    permissions() {
      return this.authStore.access.permissions;
    }
  },
  methods: {
    toggleSuperAdmin() {
      this.authStore.toggleSuperAdmin(!this.superAdmin);
    },
    getPermission(key: string) {
      return this.permissions?.[key as PermissionDetailsKey];
    },
    togglePermissions(parent: string, permission: string, value: boolean) {
      this.authStore.updatePermission({
        parent: parent,
        permission: permission,
        status: !value,
      });
    }
  }
});
</script>

<style scoped>

xxinput[type=checkbox] {
    min-width: 18px;
    min-height: 18px;
}

xxinput[type=checkbox]:hover {
    cursor: pointer;
}

</style>
